module.exports = __webpack_public_path__ + "static/media/home-icon.f28471cf.svg";